// `/settings` index — bare entry redirects to `/settings/profile` so the
// sub-nav always has an active section.

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as SettingsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => SettingsLayoutRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/settings/$section', params: { section: 'profile' } });
  },
  component: () => null,
});
